import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSupportCaseDuplicates } from '../../hooks';
import { DuplicatesModal } from '../duplicates-modal/duplicates-modal.component';

export const DuplicatesWarning: FC<{ supportCaseId: string }> = ({ supportCaseId }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const { data: duplicates = [] } = useSupportCaseDuplicates(supportCaseId);

    if (duplicates.length > 0) {
        return (
            <Box>
                <Alert
                    severity="warning"
                    action={
                        <Button color="warning" variant="contained" onClick={() => setIsOpen(true)}>
                            {t('showDuplicates')}
                        </Button>
                    }
                    sx={{ '.MuiAlert-action': { mr: 0, alignItems: 'center' } }}
                >
                    <AlertTitle>{t('duplicates')}</AlertTitle>
                    {t('duplicatesMessage', { count: duplicates.length })}
                </Alert>

                <DuplicatesModal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    supportCaseId={supportCaseId}
                    duplicates={duplicates}
                />
            </Box>
        );
    }

    return null;
};
